import React from 'react'
import classNames from 'classnames'
import { Icon, Tooltip } from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import { selectCurrentSale } from '../../../../../state/slices/currentSale/currentSaleSlice'
import { useAppSelector } from '../../../../../state/hooks'
import {
  getDisabledTooltipMessage,
  TooltipContext,
} from '../../add-row-tooltips'

interface PromoCodeLabelProps {
  disabled: boolean
  onClick: () => void
}

export const PromoCodeLabelLegacy: React.FC<PromoCodeLabelProps> = props => {
  const currentSale = useAppSelector(selectCurrentSale)
  const t = useT()
  const disabledPromoCodeMessage = getDisabledTooltipMessage(
    t,
    currentSale,
    TooltipContext.PROMOTION
  )

  return (
    <Tooltip
      className="wr-tooltip"
      direction="left"
      canBeShown={props.disabled && disabledPromoCodeMessage !== undefined}
      header={disabledPromoCodeMessage?.title ?? ''}
      message={disabledPromoCodeMessage?.message ?? ''}
      icon="info-circle"
    >
      <span
        className={classNames(
          'vd-text-label pro-sale-promo-code-link sale-total-header--link',
          {
            'vd-link': !props.disabled,
            'sale-link-disabled': props.disabled,
          }
        )}
        onClick={props.onClick}
      >
        {props.disabled && <Icon icon="fa-lock" className="vd-mr2" />}{' '}
        <T _str="Promo code" _context="Promo code link on sale footer" />
      </span>
    </Tooltip>
  )
}
